import React from 'react'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Link as MuiLink,
} from '@mui/material'
import { Link } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

interface BreadcrumbsProps {
  items: Array<{ label: string; path: string }>
  currentPage: string
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, currentPage }) => {
  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 3, flexWrap: 'wrap' }}
    >
      {items.map(item => (
        <MuiLink
          key={item.path}
          component={Link}
          to={item.path}
          underline="hover"
          color="inherit"
          sx={{ fontSize: { xs: '0.85rem', sm: '0.95rem' } }}
        >
          {item.label}
        </MuiLink>
      ))}
      <Typography
        color="text.primary"
        sx={{ fontSize: { xs: '0.85rem', sm: '0.95rem' } }}
      >
        {currentPage}
      </Typography>
    </MuiBreadcrumbs>
  )
}

export default Breadcrumbs
